export default {"src":"/_next/static/media/testimonails_top1.313a6062.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};